<template>
  <div class="inventory">
    <el-card class="anoCard">
      <div class="searchDiv" style="padding-top: 10px">

        <el-radio v-model="tableType" label="1" border @input="fetchData">两个月无变化</el-radio>
        <el-radio v-model="tableType" label="2" border @input="fetchData">库存负数</el-radio>
        <el-button
            icon="el-icon-download"
            native-type="submit"
            size="medium"
            type="primary"
            @click="handleDownload"
        >
          下载
        </el-button>
      </div>
    </el-card>
    <el-card class="tableCard">
      <el-table
          :data="currentPageData"
          style="width: 100%;margin-bottom: 20px;"
          border
          stripe

      >
        <el-table-column
            align="center"
            label="序号"
            width="80"
            type="index"
        ></el-table-column>
        <el-table-column
            align="center"
            label="仓库编码"
            prop="store_num"
        ></el-table-column>
        <el-table-column
            align="center"
            label="仓库名称"
            prop="store_name"
        ></el-table-column>
        <el-table-column
            align="center"
            label="商品编码"
            prop="goods_num"
        ></el-table-column>
        <el-table-column
            align="center"
            label="商品名称"
            prop="goods_name"
        ></el-table-column>
        <el-table-column
            align="center"
            label="商品余量"
            prop="balance_amount"
        ></el-table-column>
      </el-table>
      <el-pagination
          background
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      />
    </el-card>
  </div>
</template>

<script>
import { getIsNegative, getNoChange, negativeDown, noChangeDown } from '@/api/bi'
import {tableList} from "views/mock";
import {productdevicedetaildown} from "@/api/datastatistics";

export default {
  name: "inventory",
  data(){
    return {
      tableType: '1',
      layout: 'total, sizes, prev, pager, next, jumper', // 分页数据
      rawData: [], // 原始数据，从后端请求来的全部数据

      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的条目数
      currentPageData: [], // 当前页的数据
      total: 0, // 数据的总条数
    }
  },
  mounted() {
    // 初始进来，就请求一次数据
    this.fetchData()
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getCurrentPageData();
    },
    handleSizeChange(val){
      this.pageSize = val;
      this.getCurrentPageData(); // 当每页条目数改变时，重新获取当前页的数据
    },
    getCurrentPageData() {
      let start = (this.currentPage - 1) * this.pageSize;
      let end = this.currentPage * this.pageSize;
      this.currentPageData = this.rawData.slice(start, end);
    },
    handleDownload(){
      const excelName = this.tableType === '1'? '两个月没有变化' : '库存负数';
      const axiosMethod = this.tableType === '1' ? noChangeDown : negativeDown;
      this.$confirm(`确认下载(${excelName})数据吗？`).then(() => {
        // 下载
        axiosMethod().then((data) => {
          this.download(data);
        })
        .catch((error) => {
          this.$message.error(error);
        });
      })

    },
    download(resp) {
      const fileName = this.tableType === '1'? '两个月没有变化' : '库存负数';
      const blob = new Blob([resp.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const href = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = href;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(a.href);
      }
    },

    fetchData(){
      // 将页码相关数据，全部清到原始状态
      this.pageSize = 10;
      this.currentPage = 1;

      const axiosMethod = this.tableType === '1' ? getNoChange : getIsNegative; // 1两个月没有变化 2库存负数
      axiosMethod().then(res => {
        this.rawData = res.data;
        this.total = this.rawData.length; // 设置数据的总条数
        this.getCurrentPageData(); // 获取当前页的数据
      })

    },
  },
}
</script>

<style scoped>
.tableCard {
  margin-top: 20px;
}
</style>